<div style="background-image: linear-gradient(to right, #3791e5 0%, #45cdd8 100%);">
    <div class="container pt-4 pb-4 mb-4">
        <a href="#"><img src="assets/img/svg/logo_white.svg" /></a>
    </div>
</div>
<div class="container">
    <div class="row">
        <div class="" [innerHTML]="dynamic_html | safeHtml">
        </div>
    </div>
</div>